import {StoreTypes} from '../ActionTypes/StoreTypes';

let initialSate = {
  StoreList: [],
};

const StoreReducer = (state = initialSate, action) => {
  switch (action.type) {
    case StoreTypes.GET_STORE_LIST:
      state = {...state, StoreList: action.payload.data};
      break;

    case StoreTypes.CLEAR_STORE_LIST:
      state = {
        StoreList: [],
      };
      break;
  }
  return state;
};

export default StoreReducer;
